

<div *ngIf="moduleName == 'Active Employee'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-18 font_bold cl-black">Active Employees ({{getActiveEmpCount}})</p>
           </div>
           <div class="popup-close">
            <button (click)="onClickDownloadActiveEmpExcel(activeEmployeeList)" class="mr-10 Download fs-16 font_semibold"><img src="././assets/icon/yellowdownload.png"
              class="downIcon">Download</button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
        <table class="table">
          <thead>
            <tr>
              <th>Employee Code</th>
              <th>Employee Name</th>
              <th>Gender</th>
              <th>Date Of Joining</th>
              <th>Company name</th>
              <th>Official Email</th>
              <th>Dotted Reporting Manager Name</th>
              <th>HOD Name</th>
              <th>Band</th>
              <th>Grade</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Plant/Office Location</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of activeEmployeeList">
              <td>{{item?.employeeId}}</td>
              <td>{{item?.firstName}}&nbsp;{{item?.lastName}}</td>
              <td>{{item?.gender}}</td>
              <td>{{item?.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
              <td>{{item?.companyName}}</td>
              <td>{{item?.officialEmail}}</td>
              <td>{{item?.dottedReportingManagerName}}</td>
              <td>{{item?.hodName}}</td>
              <td>{{item?.band}}</td>
              <td>{{item?.grade}}</td>
              <td>{{item?.designation}}</td>
              <td>{{item?.department}}</td>
              <td>{{item?.workLocationCity}}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="moduleName == 'Exited Employee'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-18 font_bold cl-black">Exited employees ({{getExitedEmpCount}})</p>
           </div>
           <div class="popup-close">
            <button (click)="onClickDownloadExitedEmpExcel(exitedEmployeeList)" class="mr-10 Download fs-16 font_semibold"><img src="././assets/icon/yellowdownload.png"
              class="downIcon">Download</button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>  
      </ion-col>
    </ion-row> 
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
        <table class="table">
          <thead>
            <tr class="font_semibold ">
              <th>Employee Code</th>
              <th>Employee Name</th>
              <th>Gender</th>
              <th>Date Of Joining</th>
              <th>Company name</th>
              <th>Official Email</th>
              <th>Dotted Reporting Manager Name</th>
              <th>HOD Name</th>
              <th>Band</th>
              <th>Grade</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Plant/office Location</th>
              <th>LWD</th>
              <th>Date of Resignation</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of exitedEmployeeList" class="font_regular ">
              <td>{{item.employeeId}}</td>
              <td>{{item.firstName}}&nbsp;{{item.lastName}}</td>
              <td>{{item.gender}}</td>
              <td>{{item.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
              <td>{{item.companyName}}</td>
              <td>{{item.officialEmail}}</td>
              <td>{{item.dottedReportingManagerName}}</td>
              <td>{{item.hodName}}</td>
              <td>{{item.band}}</td>
              <td>{{item.grade}}</td>
              <td>{{item.designation}}</td>
              <td>{{item.department}}</td>
              <td>{{item.workLocationCity}}</td>
              <td>{{item.dateOfExit | date: 'dd-MM-yyyy'}}</td>
              <td>{{item.dateOfResignation | date: 'dd-MM-yyyy'}}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="moduleName == 'overallGoalSettingStatus'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">Gole Setting Status : Completed(10)</p>
           </div>
           <div class="popup-close">
            <div class="mr-20"> 
              <button class="btn">
                <span class="ml-5 mr-5 fs-12 material-icons">person</span>
                PMS
              </button>
            </div>
            <div class="mr-30"> 
              <label class="fs-16 font_regular mr-5">Incomplete (10)</label>
              <mat-slide-toggle class="toggle-element"></mat-slide-toggle>
              </div>
            <button class="btn">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
   
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
        <table class="table">
          <thead>
            <tr>
              <th>Emp. Id.</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Wt</th>
              <th>Goal setting status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>THZ0001</td>
              <td>Abhijeet Mandle</td>
              <td>HR & Admin</td>
              <td>Phi Edge</td>
              <td>April</td>
              <td>Pune</td>
              <td>100</td>
              <td class="light_bg_green">Complete</td>
            </tr>
          </tbody>
        </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="moduleName == 'overallGoalReviewStatus'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">Gole Review Status : Completed(10)</p>
           </div>
           <div class="popup-close">
            <div class="mr-20"> 
              <button class="btn">
                <span class="ml-5 mr-5 fs-12 material-icons">person</span>
                PMS
              </button>
            </div>
            <div class="mr-30"> 
              <label class="fs-16 font_regular mr-5">Incomplete (10)</label>
              <mat-slide-toggle class="toggle-element"></mat-slide-toggle>
              </div>
            <button class="btn">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
        <table class="table">
          <thead>
            <tr>
              <th>Emp. Id.</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Score</th>
              <th>Goal Review Status</th>
              <th>MIS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>THZ0001</td>
              <td>Abhijeet Mandle</td>
              <td>HR & Admin</td>
              <td>Phi Edge</td>
              <td>April</td>
              <td>Pune</td>
              <td>100</td>
              <td class="light_bg_green">Complete</td>
              <td>8/10</td>
            </tr>
          </tbody>
        </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="moduleName == 'approvedByManager'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">Manager Approval Status : Approved(10)</p>
           </div>
           <div class="popup-close">
            <div class="mr-20"> 
              <button class="btn">
                <span class="ml-5 mr-5 fs-12 material-icons">person</span>
                PMS
              </button>
            </div>
            <div class="mr-30"> 
              <label class="fs-16 font_regular mr-5">Rejected(10)</label>
              <mat-slide-toggle class="toggle-element"></mat-slide-toggle>
              </div>
            <button class="btn">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
        <table class="table">
          <thead>
            <tr>
              <th>Emp. Id.</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Total KPIs</th>
              <th>Approved by Manager</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>THZ0001</td>
              <td>Abhijeet Mandle</td>
              <td>HR & Admin</td>
              <td>Phi Edge</td>
              <td>April</td>
              <td>Pune</td>
              <td>
                <div class="display-space-between">
                  <div>
                    <p class="fs-14 font_regular text_green">A <span class="cl-black">: 02</span></p>
                  </div>
                  <div>
                    <p class="fs-14 font_regular text_red">B <span class="cl-black">: 04</span></p>
                  </div>
                </div>
              </td>
              <td>Approved</td>
            </tr>
          </tbody>
        </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>